module.exports = __webpack_public_path__ + "img/star.25ea4220.svg";